import React from "react";
import { Input, Icon } from "antd";
import "./style.scss";

class Search extends React.Component {
  render() {
    return (
      <div className="d-inline-block mr-4">
        <Input
          className="livesearch__topInput"
          placeholder="Search..."
          prefix={
            <i
              className="muted icon-search px-2 py-2 "
              style={{
                marginLeft: "-10px"
              }}
            />
          }
          style={{ width: 200 }}
          suffix={
            <i
              className="clear-field muted icon-cross px-2 py-2 "
              style={{
                marginRight: "-10px"
              }}
            />
          }
        />
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/Search/index.js